import { FunctionComponent } from 'react'
import { Daycare } from '@/types/Daycare'
import { StaffPreparationTask } from '@/types/StaffPreparationTask'
import CreateStaffPreparationTaskDialog from './createStaffPreparationTaskDialog'
import EditStaffPreparationTaskDialog from './editStaffPreparationTaskDialog'
import DeleteStaffPreparationTaskDialog from './deleteStaffPreparationTaskDialog'

export interface StaffPreparationTaskDialogCommonProps {
    open: boolean
    handleClose: () => void
    daycare: Daycare
}

export interface StaffPreparationTaskDialogCreateProps extends StaffPreparationTaskDialogCommonProps {
    mode: 'create'
    addOneStaffPreparationTask: (value: StaffPreparationTask) => void
}

export interface StaffPreparationTaskDialogEditProps extends StaffPreparationTaskDialogCommonProps {
    mode: 'edit'
    staffPreparationTaskId: number
    staffPreparationTaskName: string
    setStaffPreparationTaskName: (value: string) => void
    staffPreparationTaskDuration: string
    setStaffPreparationTaskDuration: (value: string) => void
    updateOneStaffPreparationTask: (value: StaffPreparationTask) => void
}

export interface StaffPreparationTaskDialogDeleteProps extends StaffPreparationTaskDialogCommonProps {
    mode: 'delete'
    staffPreparationTaskId: number
    removeOneStaffPreparationTask: (staffPreparationTaskId: number) => void
}

export type StaffPreparationTaskDialogProps =
    | StaffPreparationTaskDialogCreateProps
    | StaffPreparationTaskDialogEditProps
    | StaffPreparationTaskDialogDeleteProps

const StaffPreparationTaskDialog: FunctionComponent<StaffPreparationTaskDialogProps> = (
    props: StaffPreparationTaskDialogProps
) => {
    if (props.mode === 'create') {
        return <CreateStaffPreparationTaskDialog {...props} />
    } else if (props.mode === 'edit') {
        return <EditStaffPreparationTaskDialog {...props} />
    } else if (props.mode === 'delete') {
        return <DeleteStaffPreparationTaskDialog {...props} />
    }
}

export default StaffPreparationTaskDialog
